import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';

export default function useCreateBookingEvent() {
  const { hideModal } = useModal();

  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async ({
      id,
      payload,
    }: {
      id: string;
      payload: Record<string, any>;
    }) => {
      const api = new Api(args);

      const data = await api.post({
        url: `api/public/calendar/bookings/events/${id}`,
        payload,
      });

      return data;
    },
    onSuccess: () => {
      hideModal();
      toastSuccess('Successfully created booking');
    },
  });
}
